import { render } from "./OrderDocuments.vue?vue&type=template&id=297d1d72&ts=true"
import script from "./OrderDocuments.vue?vue&type=script&lang=ts"
export * from "./OrderDocuments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__